import React, { useState} from "react";
import PropTypes from "prop-types";
import { Table } from "antd";
import styled, { css } from "styled-components";
import TableFilter from "./TableFilter";
import _ from "lodash";
import { useSubscription } from '@apollo/client'
import { SUB_USER_TAGS, SUB_USERS, SUB_USER_SEGMENTS, SUB_USER_CHANNELS } from 'Util/subscriptions'
import KebabMenu from './KebabMenu'
import { THEME } from 'Util/constants';

const Container = styled.div``

const columns = [
    {
        title: 'Segment',
        dataIndex: 'label',
        key: 'label'
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status) => <span style={{ color: THEME.colors.primary}}>{status ? 'Active' : 'Inactive'}</span>
    },
    {
        title: 'Users',
        dataIndex: 'total_users',
        key: 'users',
        width: 120
    },
    {
        title: 'Push',
        dataIndex: 'total_users',
        key: 'users',
        width: 120
    },
    {
        title: 'SMS',
        dataIndex: 'total_users',
        key: 'users',
        width: 120
    },
    {
        title: 'Email',
        dataIndex: 'total_users',
        key: 'users',
        width: 120
    },
    {
        render: (row) => <KebabMenu data={row} />
    }
];

function DataTable() {
    const [search, setSearch ] = useState()
    const [data, setData] = useState([])
    const [users, setUsers] = useState([])
    const [channels, setChannels] = useState([])

    const { loading } = useSubscription(SUB_USER_SEGMENTS, {   
        onSubscriptionData({ subscriptionData: { data } }) {     
            data && setData(data.user_segments)
         }
      }
    );

    const { data: channel } = useSubscription(SUB_USER_CHANNELS, {   
        onSubscriptionData({ subscriptionData: { data } }) {     
            data && setChannels(data.user_channels)
         }
      }
    );

    const {error } = useSubscription(SUB_USERS, { variables: { status: "verified" } ,     
        onSubscriptionData({ subscriptionData: { data } }) {     
                data && setUsers(data.users)
            }
        }
     );

    const countUsers = () => {
        let tagCounts = {};

        for(let i = 0; i < users.length; i++){
            for(let j = 0; j < users[i].channel_ids?.length; j++){
                let tag = users[i].channel_ids?.[j];
                if(tagCounts[tag]){
                    tagCounts[tag]++;
                } else {
                    tagCounts[tag] = 1;
                }
            }
        }

        data.forEach((item) => {
            item.total_users = tagCounts[item.id] || 0;
          });
     }

    const searchable = data.map((obj, i) => {
        countUsers()
        let result = [];
        let concatenatedValues = "";
        columns.forEach(column => {
          if (obj[column.key] && obj[column.key] !== undefined) concatenatedValues += obj[column.dataIndex] + " ";
        });
        result.push(concatenatedValues.trim());
    
        return {
            key: i,
          ...obj,
          searchText:  result.toString()
        }
      })
    
    const filterData = (data) => {
        if(!search){
            return data
        }
        return _.filter(searchable, function (d) { 
            let query = search.toLowerCase();
            return _.includes(d.searchText.toLowerCase(), query)
        }); 
    };
    
    return (
        <Container>
            <TableFilter data={filterData(data)} column={columns} setSearch={setSearch}/>
            <Table
                loading={loading}
                columns={columns}
                dataSource={filterData(data)}
                pagination={{ defaultPageSize: 50 }}
                scroll={{ y: 500, x: 1500 }}
                rowKey={rec => parseInt(rec.id, 10)}
            />
        </Container>
    )

}

DataTable.propTypes = {
};

export default DataTable;

